import React from 'react';
import PropTypes from 'prop-types';
import {UserStateContextProvider} from './UserStateContext';
import {OutOfStockContextProvider} from './OutOfStockContext';
import {BankAccountContextProvider} from './BankAccountContext';
import {TwoGiftsContextProvider} from './TwoGiftsContext';

/*
  Don't add logic to this file.
  I made this becuase these 3 contexts are currently tightly coupled.
  If that changes down the road, keeping this logic-free makes it easier to
  re-integrate into the larger Context tree.

  - GS
*/
const PromptContextFamily = ({children}) => {
  return (
    <UserStateContextProvider>
      <BankAccountContextProvider>
        <OutOfStockContextProvider>
          <TwoGiftsContextProvider>{children}</TwoGiftsContextProvider>
        </OutOfStockContextProvider>
      </BankAccountContextProvider>
    </UserStateContextProvider>
  );
};

PromptContextFamily.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PromptContextFamily;
